import Dialog, {DialogProps} from '@mui/material/Dialog'
import {useIsLoading} from '@oc/shell-core'
import {makeStyles} from '@oc/styles'
import {observer} from 'mobx-react-lite'

const useStyles = makeStyles(theme => ({
    rootLoader: {
        position: 'absolute',
        left: 0,
        top: 0,
        height: '100%',
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: theme.zIndex.modal + 1,
        background: 'rgba(255, 255, 255, 0.5)',
        flexDirection: 'column'
    },
    rootLoaderHidden: {
        display: 'none'
    }
}))

function _dialogWithLoader(props: DialogProps) {
    const isLoading = useIsLoading()
    const {classes, cx} = useStyles()

    const rootLoaderClass = cx(classes.rootLoader, {
        [classes.rootLoaderHidden]: !isLoading
    })
    return (
        <Dialog {...props}>
            <div className={rootLoaderClass}></div>
            {props.children}
        </Dialog>
    )
}

export const DialogWithLoader = observer(_dialogWithLoader)
